import { action as apiAction } from 'api/Api'
import {
  setArchived
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
}

const requestUnarchiveCard = (payload: Payload) => async dispatch => {
  const { cardId } = payload

  const optimisticAction = optimisticDispatch(dispatch, setArchived({
    id: cardId,
    isArchived: false
  }))

  try {
    await apiAction('UnarchiveCard', {
      cardId,
      position: 'top'
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestUnarchiveCard
